// @flow
import React from "react";

import Selector from '../index';
import type { Props } from '../index'
import { useType_Expos } from 'redux/hooks'


export default ({ value, onChange, ...props }: Props) => {

    const data = useType_Expos();

    return (
        <Selector
            {...props}
            label="Sélection du type d'expo"
            value={value}
            onChange={onChange}
            data={data}
        />
    )
};